import React, { useState, useContext, useEffect, useRef } from "react";
import { ModalCreateCollaborationContainer, ProfileImage } from "./ModalCreateCollaborationStyled";

import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';
import { formatNumber, getBase64, toUpperCase } from "../../services/generalSevices";
import Select from 'react-select';

import close from './../../utils/images/close_circle_outline.svg';
import back from './../../utils/images/arrow_back.svg';
import logo from './../../utils/images/name_logo_dark.svg';
import plus from './../../utils/images/plus.png';
import less from './../../utils/images/less.png';
import avatar from './../../utils/images/avatar_fluincr.png';
import tiktok from './../../utils/images/tiktok_opacity.svg';
import facebook from './../../utils/images/facebook_color.svg';
import instagram from './../../utils/images/instagram_color.svg';
import youtube from './../../utils/images/youtube_color.svg';
import twitter from './../../utils/images/twitter_color.svg';
import check from './../../utils/images/check_circle_darker.svg';
import star from './../../utils/images/star.svg';
import share from './../../utils/images/share_new.svg';
import gift from './../../utils/images/gift.svg';
import upload from './../../utils/images/upload.svg';
import shoppingCart from './../../utils/images/shopping_cart_white.svg';
import deleteIcon from './../../utils/images/delete_grey.svg';
import bell from './../../utils/images/bell.png';
import { LangContext } from "../../context/langContext";
import { UserContext } from "../../context/userContext";
import { getInfluencerData, getServicesWithNameByInfluencer } from "../../api/influencerApi";
import { getCompanyData } from "../../api/companyApi";
//import { CartContext } from "../../context/cartContext";
import { postCollaboration } from "../../api/collaborationApi";
import { postFileBase64 } from "../../api/fileApi";
import Spinner from "../Spinner/Spinner";
import SocialMedia from "../../components/SocialMedia/SocialMedia";
import { getConvertCurrency } from "../../api/exchangeApi";
import { CurrencyContext } from "../../context/currencyContext";
import LikeInfluencer from "../LikeInfluencer/LikeInfluencer";
import SelectProduct from "../SelectProduct/SelectProduct";
import SmallSpinner from "../SmallSpinner/SmallSpinner";
import ChargingSpinner from "../ChargingSpinner/ChargingSpinner";
import Alert from "../Alert/Alert";

export default function ModalCreateCollaboration({ setShowCreateCollaboration, isFavorite, setIsFavorite }) {

    const shareRef = useRef(null);
    const { locale } = useContext(LangContext);
    const { id, products, userType, userToken, uniqueName, account } = useContext(UserContext);
    const { currency } = useContext(CurrencyContext);

    const navigate = useNavigate();
    const { username } = useParams();
    const intl = useIntl();

    const [isLoading, setIsLoading] = useState(false);
    const [showSmallSpinner, setShowSmallSpinner] = useState(false);

    const [profileImage, setProfileImage] = useState('');
    const [influencerId, setInfluencerId] = useState(null);
    const [name, setName] = useState('');
    const [lastName, setLastName] = useState('');
    const [rating, setRating] = useState(null);
    const [city, setCity] = useState('');
    const [country, setCountry] = useState({})
    const [languages, setLanguages] = useState([]);
    const [categories, setCategories] = useState([]);
    const [categoriesName, setCategoriesName] = useState([]);
    const [categoriesNombre, setCategoriesNombre] = useState([]);
    const [verified, setVerified] = useState(false);

    const [influencerTiktok, setInfluencerTiktok] = useState();
    const [influencerInstagram, setInfluencerInstagram] = useState();
    const [influencerFacebook, setInfluencerFacebook] = useState();
    const [influencerTwitter, setInfluencerTwitter] = useState();
    const [influencerYoutube, setInfluencerYoutube] = useState();

    const [sendGift, setSendGift] = useState(false);

    const [productsOptions, setProductsOptions] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState();

    const [showCommentsArea, setShowCommentsArea] = useState(false);

    const [showTiktok, setShowTiktok] = useState(false);
    const [showInstagram, setShowInstagram] = useState(false);
    const [showFacebook, setShowFacebook] = useState(false);
    const [showTwitter, setShowTwitter] = useState(false);
    const [showYoutube, setShowYoutube] = useState(false);

    const [influencerServices, setInfluencerServices] = useState([]);

    const [comments, setComments] = useState('');
    const [base64File, setBase64File] = useState('');
    const [promotionalCode, setPromocionalCode] = useState('');

    const [productId, setProductId] = useState(null);
    const [productName, setProductName] = useState(null);
    const [productImage, setProductImage] = useState(null);
    const [productPrice, setProductPrice] = useState(null);
    const [auxProductPrice, setAuxProductPrice] = useState(null);
    const [collaborationTotal, setCollaborationTotal] = useState(null);
    const [auxCollaborationTotal, setAuxCollaborationTotal] = useState(null);

    const [disabled, setDisabled] = useState(true);

    const [showNotServices, setShowNotServices] = useState(false);

    const [alreadyShowAdd, setAlreadyShowAdd] = useState(false);
    const [showAlertGiftProduct, setShowAlertGiftProduct] = useState(false);

    //const { setShoppingCartCount } = useContext(CartContext);
    const [showSocialMedia, setShowSocialMedia] = useState(false);
    const url = window.location.href;
    const auxCurrency = currency.symbol;

    useEffect(() => {
        if (influencerId !== null) {
            setIsLoading(true);
            getServicesWithNameByInfluencer({ influencerId: influencerId }).then((response) => {

                if (response.length < 1) {
                    setShowNotServices(true);
                }
                let auxServices = [...response];

                const newServices = response.map(async (service, index) => {
                    return await getConvertCurrency({ amount: service.rate }).then((responseRate) => {
                        auxServices[index].quantity = 0;
                        auxServices[index].currency = Number(responseRate[auxCurrency]).toFixed(0);
                    })
                })

                Promise.all(newServices).then(() => {
                    setInfluencerServices(auxServices)
                    setIsLoading(false);
                })
            })
        }
    }, [influencerId])


    useEffect(() => {
        let auxServices = [...influencerServices];

        const newServices = influencerServices.map(async (service, index) => {
            getConvertCurrency({ amount: service.rate }).then((response) => {
                auxServices[index].currency = response[auxCurrency].toFixed(0);
            })
        })
        Promise.all(newServices).then(() => {
            setInfluencerServices(auxServices)
        })
    }, [currency])


    const addQuantity = (index) => {
        let auxServices = [...influencerServices];
        auxServices[index].quantity = auxServices[index].quantity + 1;
        setInfluencerServices(auxServices)
    }

    const removeQuantity = (index) => {
        let auxServices = [...influencerServices];
        if (auxServices[index].quantity > 0) {
            auxServices[index].quantity = auxServices[index].quantity - 1;
        }
        setInfluencerServices(auxServices)
    }



    useEffect(() => {

        let total = 0;
        influencerServices.map((service) => {
            total = total + (service.rate * service.quantity)
        })

        if (sendGift) {
            if (productPrice !== null) {
                if (productPrice < total) {
                    total = total - productPrice;
                } else {
                    total = 0;
                }
            }
        }

        setCollaborationTotal(total);
    }, [influencerServices, sendGift, productPrice])

    useEffect(() => {

        if (userType === 'company') {

            if (productName !== null) {
                for (let i = 0; i < influencerServices.length; i++) {
                    if (influencerServices[i].quantity > 0) {
                        setDisabled(false);
                        break;
                    } else {
                        setDisabled(true)
                    }
                }
            } else {
                setDisabled(true)
            }
        }

    }, [influencerServices, productName])


    useEffect(() => {

        /* const auxProducts = []
        products.map((product) => {
            auxProducts.push({ label: product.name, value: product.id, price: product.price?.USD, image: product.image })
        })
        setProductsOptions(auxProducts) */

        getInfluencerData({ userName: username }).then((response) => {
            setProfileImage(response.imageProfile);
            setInfluencerId(response.id);
            setName(response.givenName)
            setLastName(response.familyName)
            setCity(response.city);
            setCountry(response.country);

            setRating(response.rating);

            const auxLanguages = [];
            response.language?.map((language) => {
                auxLanguages.push(language.languageId.convention)
            })
            setLanguages(auxLanguages)

            const auxCategories = [];
            const auxCategoriesNombre = [];
            response.category?.map((category) => {
                auxCategories.push(category.categoryId.name)
                auxCategoriesNombre.push(category.categoryId.nombre)
            })
            setCategories(auxCategories);
            setCategoriesName(auxCategories);
            setCategoriesNombre(auxCategoriesNombre);

            setVerified(response.attributes.verified);

            setInfluencerTiktok(response.followers.tiktok);
            setInfluencerInstagram(response.followers.instagram);
            setInfluencerFacebook(response.followers.facebook);
            setInfluencerTwitter(response.followers.twitter);
            setInfluencerYoutube(response.followers.youtube);
        })

    }, [])


    useEffect(() => {
        if (collaborationTotal !== null) {
            getConvertCurrency({ amount: collaborationTotal }).then((response) => {
                setAuxCollaborationTotal(response[auxCurrency].toFixed(0))
            })
        }
    }, [collaborationTotal, auxCurrency])

    const onSelectproduct = (event) => {
        setProductId(event.value)
        setProductPrice(event.price)
        setProductName(event.label)
        setProductImage(event.image)
        getConvertCurrency({ amount: event.price }).then((response) => {
            setAuxProductPrice(response[auxCurrency].toFixed(0))
        })
    }


    const sendCart = () => {

        setIsLoading(true);

        const collaborationBody = {
            status: 0,
            comment: comments,
            document: "",
            totalPrice: collaborationTotal,
            typeCurrency: 'USD',
            idInfluencer: influencerId,
            idProduct: productId,
            codeInfluencer: "",
            discountInfluencer: 0,
            codePlatform: "",
            discountPlatform: 0,
            readCompany: true,
            readInfluencer: false,
            gift: false,
            items: [
            ]
        }

        influencerServices.map((service) => {
            if (service.quantity > 0) {
                for (let i = 0; i < (service.quantity); i++) {
                    collaborationBody.items.push({
                        title: JSON.stringify(service.services),
                        price: service.rate,
                        status: 0,
                        content: "empty",
                        quantity: service.quantity,
                        readCompany: false,
                        readInfluencer: false,
                    })
                }
            }
        })

        if (sendGift) {
            collaborationBody.gift = true;
            collaborationBody.giftValue = productPrice;
        }

        if (base64File !== '') {

            const fileBody = {
                base64File: base64File.base64.split(',')[1],
                formatFile: base64File.type,
                address: `company/${account}/collaboration`
            }

            postFileBase64({ body: fileBody, token: userToken }).then((responseFile) => {

                if (responseFile.length > 0) {

                    collaborationBody.document = responseFile

                    postCollaboration({ collaborationBody: collaborationBody, token: userToken }).then((response) => {
                        setIsLoading(false)
                        setShowCreateCollaboration(false)
                        navigate('/mycart')
                    })

                }
            })
        } else {
            postCollaboration({ collaborationBody: collaborationBody, token: userToken }).then((response) => {
                setIsLoading(false)
                setShowCreateCollaboration(false)
                navigate('/mycart')
            })
        }
    }

    useEffect(() => {
        function handleClickOutside(event) {

            if (shareRef.current && !shareRef.current.contains(event.target)) {
                setShowSocialMedia(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [shareRef])

    const showSpinner = () => {
        setShowSmallSpinner(true);
        setTimeout(() => {
            setShowSmallSpinner(false);
        }, 3000);
    }

    return (
        <ModalCreateCollaborationContainer>

            <img src={close} alt="close" className="close" onClick={() => { setShowCreateCollaboration(false) }} />

            <div className="collaborationBody">

                <div className="goBack" onClick={() => { setShowCreateCollaboration(false) }}>
                    <img src={back} alt="back" className="backIcon" />
                    <p className="backText" ><FormattedMessage id="go_back" defaultMessage="ir atrás" /></p>
                </div>
                <h3 className="mobileTitle"><FormattedMessage id="create_collaboration_title" defaultMessage="Crea tu colaboración " /> <img src={logo} alt="logo" className="logo" /></h3>

                <div className="influencerData">

                    <div className="profile">
                        <div className="likeProfile">
                            {(userType === 'company' || userToken === null) && (<LikeInfluencer profileId={influencerId} isFavorite={isFavorite} setIsFavorite={setIsFavorite} />)}
                        </div>

                        <ProfileImage image={(profileImage !== '' && profileImage !== null) ? profileImage : avatar} />

                        <div className="networks">
                            {(influencerTiktok !== undefined) && (<div className="network">
                                <img src={tiktok} alt="tiktok" className="networkIcon" onMouseOver={() => { setShowTiktok(true) }} onMouseOut={() => { setShowTiktok(false) }} />
                                {(showTiktok) && (<p>{(influencerTiktok < 999) ? influencerTiktok : (influencerTiktok < 999999) ? `${(influencerTiktok / 1000).toFixed(1)} k` : `${(influencerTiktok / 1000000).toFixed(1)} m`}</p>)}
                            </div>)}

                            {(influencerInstagram !== undefined) && (<div className="network">
                                <img src={instagram} alt="instagram" className="network" onMouseOver={() => { setShowInstagram(true) }} onMouseOut={() => { setShowInstagram(false) }} />
                                {(showInstagram) && (<p>{(influencerInstagram < 999) ? influencerInstagram : (influencerInstagram < 999999) ? `${(influencerInstagram / 1000).toFixed(1)} k` : `${(influencerInstagram / 1000000).toFixed(1)} m`}</p>)}

                            </div>)}

                            {(influencerFacebook !== undefined) && (<div className="network">
                                <img src={facebook} alt="facebook" className="network" onMouseOver={() => { setShowFacebook(true) }} onMouseOut={() => { setShowFacebook(false) }} />
                                {(showFacebook) && (<p>{(influencerFacebook < 999) ? influencerFacebook : (influencerFacebook < 999999) ? `${(influencerFacebook / 1000).toFixed(1)} k` : `${(influencerFacebook / 1000000).toFixed(1)} m`}</p>)}
                            </div>)}

                            {(influencerTwitter !== undefined) && (<div className="network">
                                <img src={twitter} alt="twitter" className="network" onMouseOver={() => { setShowTwitter(true) }} onMouseOut={() => { setShowTwitter(false) }} />
                                {(showTwitter) && (<p>{(influencerTwitter < 999) ? influencerTwitter : (influencerTwitter < 999999) ? `${(influencerTwitter / 1000).toFixed(1)} k` : `${(influencerTwitter / 1000000).toFixed(1)} m`}</p>)}
                            </div>)}

                            {(influencerYoutube !== undefined) && (<div className="network">
                                <img src={youtube} alt="youtube" className="network" onMouseOver={() => { setShowYoutube(true) }} onMouseOut={() => { setShowYoutube(false) }} />
                                {(showYoutube) && (<p>{(influencerYoutube < 999) ? influencerYoutube : (influencerYoutube < 999999) ? `${(influencerYoutube / 1000).toFixed(1)} k` : `${(influencerYoutube / 1000000).toFixed(1)} m`}</p>)}
                            </div>)}

                        </div>
                        <button className="seeProfile" onClick={() => { setShowCreateCollaboration(false) }}>
                            <FormattedMessage id="create_collaboration_text_8" defaultMessage="Ver perfil" />
                        </button>
                    </div>
                    <div className="dataProfile">
                        <div className="fileName">
                            <p className="name">{(toUpperCase({ fullName: `${name.split(' ')[0]} ${(name.split(' ')[1] !== undefined) ? (name.split(' ')[1]?.charAt(0)) : ('')} ${lastName.split(' ')[0]}` }))}
                            </p>

                            {(verified) && (<img src={check} alt="check" className="check" />)}

                            <div className="subItem"><p className="score">{(rating === null) ? 'N/R' : rating}</p><img src={star} alt="star" className="star" /></div>
                        </div>
                        <div className="fileCountry">
                            <p className="city">
                                {(city !== null) && (<p>
                                    {(locale === 'es-CO') ? country?.nombre : country?.name},
                                    {` ${city}`}
                                </p>)
                                }
                            </p>
                            <p className="languages"> {languages.map((lang, index) => {
                                if (index < 1) {
                                    return (lang)
                                } else {
                                    return (`/ ${lang}`)
                                }
                            })}</p>

                            <div className="share" ref={shareRef}>
                                <img src={share} alt="edit" className="shareIcon" onClick={() => { setShowSocialMedia(!showSocialMedia) }} />
                                {(showSocialMedia) && (<SocialMedia shareUrl={url} />)}
                            </div>
                        </div>
                        <p className="fileCategories">
                            {(locale === 'es-CO') ? ((categories[0] !== '') && (<p>
                                {categoriesNombre.map((categ, index) => {
                                    if (index < 4) {
                                        return `#${categ} `
                                    }
                                })}
                            </p>)) : ((categories[0] !== '') && (<p>
                                {categoriesName.map((categ, index) => {
                                    if (index < 4) {
                                        return `#${categ} `
                                    }
                                })}
                            </p>))}
                        </p>

                    </div>


                </div>

                <div className="collaborationData">

                    <div className="collaborationQuantity">

                        <div className="quantity">
                            <h3><FormattedMessage id="create_collaboration_title" defaultMessage="Crea tu colaboración" /> <img src={logo} alt="logo" className="logo" /></h3>

                            <SelectProduct onSelect={(event) => onSelectproduct(event)} selectedProduct={selectedProduct} setSelectedProduct={setSelectedProduct} />

                            {(showNotServices) && (<div className="notServices"><p><FormattedMessage id="create_collaboration_text_1" defaultMessage="El influencer no tiene ningún servicio" /></p></div>)}

                            {influencerServices.map((service, index) => {
                                return (
                                    <div className="file">
                                        <p className="type">{(locale === 'es-CO') ? service.services.nombre : service.services.name}</p>
                                        <div className="right">
                                            <div className="buttons">
                                                <button onClick={() => { removeQuantity(index) }}><img src={less} alt="less" className="addIcon" /></button>
                                                <span>{service.quantity}</span>
                                                <button onClick={() => { addQuantity(index) }}>
                                                    <img src={plus} alt="add" className="addIcon" />
                                                </button>
                                            </div>
                                            <p className="price">{currency.symbol} {formatNumber(service.currency)}</p>
                                        </div>
                                    </div>
                                )
                            })}

                        </div>
                        <div className="aditionalInfo">
                            <hr />
                            <div className="giftContainer">
                                <div className="giftInfo">
                                    <input type="checkbox" name="gift" checked={sendGift} onChange={(event) => { setSendGift(event.target.checked) }} />
                                    <img src={gift} alt="gift" className="giftIcon" />
                                    <span className="giftText"><FormattedMessage id="create_collaboration_text_2" defaultMessage="Envio completo del producto al influencer" /></span>
                                </div>
                                {(sendGift) && (<p className="giftPrice">{(productPrice !== null) && `(${currency.symbol} -${formatNumber(auxProductPrice)})`}</p>)}
                            </div>

                            <div className="commentContainer">
                                <div className="addComments">
                                    <button onClick={() => { setShowCommentsArea(!showCommentsArea) }}>
                                        <img src={plus} alt="add" className="plusIcon" />
                                    </button>
                                    <p className="commentText"><FormattedMessage id="create_collaboration_text_3" defaultMessage="Comentarios / Agregar archivo" /></p>
                                </div>
                                {(showCommentsArea) && (
                                    <div className="comments">
                                        <textarea name="" id="" cols="30" rows="10" value={comments} onChange={(event) => { setComments(event.target.value) }}></textarea>

                                        {(base64File === '') && (<label htmlFor="collaboration-file-input" className="fileLabel">
                                            <img src={upload} alt="upload" className="uploadIcon" />
                                        </label>)}

                                        {(showSmallSpinner) && (<div className="chargingContainer">
                                            <ChargingSpinner />
                                        </div>)}

                                        {(base64File !== '' && showSmallSpinner === false) && (
                                            <img src={deleteIcon} alt="upload" className="uploadIcon" onClick={() => { setBase64File('') }} />
                                        )}

                                        <input type="file" id="collaboration-file-input" accept=".pdf, .txt, application/pdf, .doc, .docx, application/msword, .xls,.xlsx, application/vnd.ms-excel, .ppt, .pptx, application/vnd.ms-powerpoint, text/plain,.png, .jpg, .jpeg, image/png, image/jpg" onChange={(e) => {
                                            getBase64({ file: e.target.files[0] }).then((data) => {
                                                if (e.target.files[0] !== undefined) {
                                                    setBase64File({ base64: data, name: e.target.files[0].name, /* type: e.target.files[0].type.split('/')[1] */type: e.target.files[0].name.split('.').reverse()[0] });
                                                }
                                            }
                                            );
                                            showSpinner()
                                        }} />
                                    </div>
                                )}
                            </div>

                            {/* <p className="promotionalTitle"><FormattedMessage id="create_collaboration_text_4" defaultMessage="Gift card y código promocional" /></p>
                            <div className="promotionalInputContainer">
                                <input type="text" placeholder={intl.formatMessage({ id: "create_collaboration_text_5" })} value={promotionalCode} onChange={(event) => setPromocionalCode(event.target.value)} />
                                <button><FormattedMessage id="create_collaboration_text_6" defaultMessage="Aplicar" /></button>
                            </div> */}

                            <button className={`addShoppingCart ${disabled && 'disabledButton'}`} onClick={() => {
                                if (sendGift === false && alreadyShowAdd === false) {
                                    setAlreadyShowAdd(true);
                                    setShowAlertGiftProduct(true);
                                } else {
                                    sendCart()
                                }
                            }} disabled={disabled}>
                                <span><FormattedMessage id="create_collaboration_text_7" defaultMessage="Añadir al carrito" />
                                    <img src={shoppingCart} alt="shopping cart" className="cart" /></span>
                                <span>{currency.symbol} {formatNumber(auxCollaborationTotal)}</span>
                            </button>
                            <p className="requiredText">*<FormattedMessage id="create_collaboration_text_9" defaultMessage="Inicio de sesión requerido para Agregar al carrito" /></p>
                        </div>
                    </div>

                </div>

            </div>
            {(isLoading) && (<Spinner />)}
            {(showAlertGiftProduct) && (<Alert
                image={bell}
                title={<FormattedMessage id="alert_send_product_title" defaultMessage="¡Recordatorio!" />}
                text={<><p style={{ textAlign: 'center' }}><FormattedMessage id="alert_send_product_text_1" defaultMessage="Nos hemos dado cuenta de que no estás enviando producto(s) gratuito(s) para esta colaboración y de que " /><span style={{ textTransform: 'capitalize' }}>{name}</span><FormattedMessage id="alert_send_product_text_2" defaultMessage=" puede no tener acceso a tu producto para crear contenido." /></p><p style={{ textAlign: 'center' }}><FormattedMessage id="alert_send_product_text_3" defaultMessage="Por favor, haz clic en “Entiendo” a continuación para confirmar." /></p></>}
                confirmText={<span style={{ fontWeight: 'bold' }}><FormattedMessage id="alert_send_product_button" defaultMessage="¡Entendido!" /></span>}
                onConfirm={() => { setShowAlertGiftProduct(false) }}
                setShowAlert={setShowAlertGiftProduct} />)}
        </ModalCreateCollaborationContainer>
    )
}